import { useState, useEffect, useRef } from 'react'

export default function ProgressiveImage({ placeholder, src, children }) {
  const [state, setState] = useState({ loading: true, src: placeholder })
  const imageRef = useRef()
  const mountedRef = useRef(true)

  useEffect(() => {
    const reset = () => {
      mountedRef.current = false
      imageRef.current.onLoad = null
      imageRef.current.onError = null
    }

    setState((s) => ({ ...s, loading: true }))

    async function init() {
      if (imageRef.current) {
        reset()
      }

      const image = new Image()
      image.onload = () => mountedRef.current && setState({ src })
      image.onerror = () => mountedRef.current && setState((s) => ({ ...s, loading: false }))
      image.src = src
      imageRef.current = image
    }

    init()

    return reset
  }, [src])

  if (!children || typeof children !== 'function') {
    throw new Error(`ProgressiveImage requires a function as its only child`)
  }

  return children(state.src, state.loading)
}
